enum FieldType {
  STRING = 1,
  TEXT = 2,
  IMAGE_URL = 3,
}

export default FieldType;
